import { formatPersonName } from "@bezbolisno/kit/person-name";
import { type Role, toRole } from "@bezbolisno/kit/rbac";
import { queryOptions } from "@tanstack/react-query";
import { authClient } from "./auth";
import { keys } from "./keys";

export interface SessionUser {
  id: string;
  /** "Імʼя Прізвище" — formatted here from the two parts; nothing stores it. */
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  role: Role;
  /** The current session's row id — /profile marks it as "this device" in the sessions list. */
  sessionId: string;
}

/**
 * The staff session as a query: route loaders `ensureQueryData` it, the shell reads it, a
 * 401 anywhere invalidates it (see queryClient's global error handling in main.tsx).
 */
export const sessionQuery = queryOptions({
  queryKey: keys.session,
  queryFn: async (): Promise<SessionUser | null> => {
    const { data } = await authClient.getSession();
    if (!data?.user) return null;
    // Better Auth's `name` is the given name (the API maps it onto first_name).
    const u = data.user as {
      id: string;
      name: string;
      lastName?: string | null;
      email: string;
      role?: string;
    };
    const lastName = u.lastName ?? "";
    return {
      id: u.id,
      name: formatPersonName({ first: u.name, last: lastName || null }),
      firstName: u.name,
      lastName,
      email: u.email,
      role: toRole(u.role),
      sessionId: data.session.id,
    };
  },
  staleTime: 60_000,
});
